import {
    GET_ADMIN_USER_LIST,
    GET_ADMIN_USER_LIST_FAILURE,
    GET_ADMIN_USER_LIST_SUCCESS,
    GET_ADMIN_USER_LIST_SEARCH,
    GET_ADMIN_USER_LIST_SEARCH_FAILURE,
    GET_ADMIN_USER_LIST_SEARCH_SUCCESS,
    GET_ADMIN_ASSOCIATED_ACCOUNT,
    GET_ADMIN_ASSOCIATED_ACCOUNT_FAILURE,
    GET_ADMIN_ASSOCIATED_ACCOUNT_SUCCESS,
    GET_USER_ROLE,
    GET_USER_ROLE_FAILURE,
    GET_USER_ROLE_SUCCESS,
    GET_ARDT_LIST,
    GET_ARDT_LIST_FAILURE,
    GET_ARDT_LIST_SUCCESS,
    GET_ARDT_REGION_LIST_SUCCESS,
    GET_ARDT_DISTRICT_LIST_SUCCESS,
    GET_ARDT_TERRITORY_LIST_SUCCESS,
    GET_ADMIN_ASSOCIATED_PHYSICIAN,
    GET_ADMIN_ASSOCIATED_PHYSICIAN_FAILURE,
    GET_ADMIN_ASSOCIATED_PHYSICIAN_SUCCESS,
    GET_NEW_ASSIGNMENT,
    GET_NEW_ASSIGNMENT_FAILURE,
    GET_NEW_ASSIGNMENT_SUCCESS,
    CLEAR_NEW_ASSIGNMENT,
    SET_ADMIN_FILTER,
    SET_ADMIN_SEARCH,
    SET_FILTER_PAGE,
    GET_ADMIN_DATA_FROM_SEARCH,
    CLEAR_SEARCH_RESULT,
    SET_SEARCH_TYPE,
    SET_ADMIN_SEARCH_PARAMS,
    SET_USER_ROLE_CHANGE,
    SET_LOGGED_USER_ROLE_CHANGE,
    UPDATE_USER_SUCCESS,
    UPDATE_USER,
    SHOW_LOCAL_EXPANDED_VIEW,
    RESET_ROLES,
    RESET_TERRITORY,
    SET_APPLIED_VIEW_ADMIN_FILTER,
    SET_CLEAR_FILTER,
    SET_FILTER_TYPE,
    GET_DISTRICT_SUCCESS,
    GET_DISTRICT_FAILURE,
    GET_TERRITORY_SUCCESS,
    GET_SALES_ORG_VIEW,
    SET_ADMIN_FILTERS,
    SET_FILTER_PARAMS,
    SET_FILTER_VIEW_ADMIN,
    SET_POPUPCLOSE_FROM_HEADER,
    SET_ADMIN_FILTER_PARAM_VALUES,
    SET_MORE_CLICK,
    GET_FILTER_DATA,
    SET_CHECKBOX_CHECKED,
    SET_SELECTED_SALESORG,
    SET_DEFAULT,
    SET_POP_DONE,
    SET_SALESORGVIEW_DATA,
    UPDATE_SALES_ORG,
    SET_SELECTED_VALUE,
    SET_SHOW_PROXY,
    SET_PROXYTAB_DATA,
    SET_TAB_ADMIN_PROXY,
    SET_FILER_AFTER_IMPERSONATION,
    CLEAR_ERROR_MESSAGE,
    GET_ARDT_SUBDISTRICT_LIST_SUCCESS,
    GET_ARDT_LEVEL4_LIST_SUCCESS,
    RESET_ARDT_LIST,
    SET_AREA
} from 'src/pages/admin/redux/action/actionTypes.js';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {ADMINFILTERPARAMETERS} from 'src/constants/appConstants';

const initialState = {
    adminUserList: [],
    searchResults: [],
    status: '',
    associatedAccount: [],
    associatedPhysician: [],
    userRole: [],
    areaList: [],
    regionList: [],
    districtList: [],
    subdistrictList: [],
    territoryList: [],
    level4List: [],
    newAssignment: [],
    adminSearchOpen: false,
    adminFilterOpen: false,
    filterPage: false,
    searachType: 'Users',
    searchParams: '',
    totalRecords: '',
    totalSearchRecords: '',
    adminFilterParamValues: '',
    totalAssociatedPhysician: '',
    totalAssociatedAccount: '',
    userRoleChange: '',
    updateUserStatus: '',
    loading: false,
    filterParams: {},
    associatedPhysicianStatus: false,
    districtSuccess: true,
    moreClick: false,
    territorySuccess: true,
    roleSuccess: true,
    popupClose: false,
    filterDataOpen: false,
    salesOrgSuccess: true,
    salesOrg: [],
    appliedView: {
        appliedsalesOrgView: [],
        appliedDistrict: {},
        appliedTerritory: {},
        appliedRole: {}
    },
    selectedAdminFilters: {},
    showLocalExpandedView: {
        salesOrgView: true,
        districtView: false,
        territoryView: false,
        roleView: false
    },
    clearFilter: false,
    isFilterType: 'initial',
    districts: [],
    territories: [],
    checked: [],
    defaultStatus: false,
    popDone: false,
    selectedSalesOrgView: [],
    loadingSearch: false,
    selectedViews: {
        salesOrgView: [
            {
                name: 'All',
                value: 'All',
                isChecked: true,
                isDefault: true
            },
        ],
        districtView: {
            id: 'All District',
            name: 'All'
        },
        territoryView: {
            id: 'All Territory',
            name: 'All'
        },
        roleView: {
            id: 'All',
            name: 'All'
        }
    },
    showProxy: false,
    proxyTabData: {},
    accountTabActiveId: 'proxiesTab1',
    errorStatusCode: '',
    errorStatusMessage: '',
    newAssignmentStatusCode: '',
    filterAfterImpersonation: false,
    area: ''
};

const updateUserRole = (data, action) => {
    let currentUser = data && data.filter((e) => e.userRolesCode === action);

    let newUserRole = currentUser && currentUser[0] && currentUser[0].userRolesName;

    return newUserRole;
};

const hasObjectProperty = (target, propertyName) => {
    return !!target && Object.prototype.hasOwnProperty.call(target, propertyName);
};

const AdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADMIN_USER_LIST:

            return {
                ...state,
                // adminUserList: [],
                defaultStatus: false,
                loading: true
            };
        case SET_POPUPCLOSE_FROM_HEADER:
            return {
                ...state,
                popupClose: action.payload
            };

        case GET_ADMIN_USER_LIST_SUCCESS: {
            const response = action?.adminUserList || {};
            const hasSalesOrgView = hasObjectProperty(response, 'salesOrgFilter') && Array.isArray(response.salesOrgFilter) && response.salesOrgFilter.length > 0;

            return {
                ...state,
                adminUserList: Array.isArray(response.users) ? response.users : [],
                adminUser: hasSalesOrgView ? response : state.adminUser,
                totalRecords: response.totalRecords || 0,
                status: response.statusCode || state.status,
                sortOrder: response.sortOrder || state.sortOrder,
                sortParam: response.sortParam || state.sortParam,
                loading: false,
                defaultStatus: !!action?.isDefault,
                salesOrgViewData: hasObjectProperty(response, 'salesOrgFilter') && action?.isDefault ? response.salesOrgFilter : state.salesOrgViewData
            };
        }
        case GET_ADMIN_USER_LIST_SEARCH:
            return {
                ...state,
                // adminUserList: [],
                loadingSearch: true
            };
        case UPDATE_SALES_ORG:
            return {
                ...state,
                // adminUserList: [],
                adminUser: {
                    ...state.adminUser,
                    salesOrgFilter: action.payload
                }
            };
        case SET_FILER_AFTER_IMPERSONATION:
            return {
                ...state,
                filterAfterImpersonation: action.payload
            };
        case GET_ADMIN_USER_LIST_SEARCH_SUCCESS: {
            const response = action?.adminUserList || {};

            return {
                ...state,
                totalSearchRecords: response.totalRecords || 0,
                searchResults: Array.isArray(response.users) ? response.users : [],
                status: response.statusCode || state.status,
                loadingSearch: false
            };
        }
        case CLEAR_SEARCH_RESULT:
            return {
                ...state,

                searchResults: []
            };
        case UPDATE_USER:
            return {
                ...state,
                updateUserStatus: ''
            };
        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                updateUserStatus: action.payload.statusCode
            };
        case SET_DEFAULT:
            return {
                ...state,
                defaultStatus: action.payload
            };
        case GET_ADMIN_USER_LIST_FAILURE:
            return {
                ...state,
                loading: false
            };
        case GET_ADMIN_USER_LIST_SEARCH_FAILURE:
            return {
                ...state,
                loading: false
            };

        case GET_ADMIN_ASSOCIATED_ACCOUNT:
            return {
                ...state,
                associatedAccount: [],
                associatedAccountStatus: true
            };

        case GET_ADMIN_ASSOCIATED_ACCOUNT_SUCCESS:
            return {
                ...state,
                associatedAccount: action.associatedAccount.accountsList,
                status: action.associatedAccount.statusCode,
                totalAssociatedAccount: action.associatedAccount.accountsFetched,
                associatedAccountStatus: false
            };

        case GET_ADMIN_ASSOCIATED_ACCOUNT_FAILURE:
            return {
                ...state,
                associatedAccountStatus: false
            };

        case GET_ADMIN_ASSOCIATED_PHYSICIAN:
            return {
                ...state,
                associatedPhysician: [],
                associatedPhysicianStatus: true
            };

        case GET_ADMIN_ASSOCIATED_PHYSICIAN_SUCCESS:
            return {
                ...state,
                associatedPhysician: action.associatedPhysician.physicianDetails,
                status: action.associatedPhysician.statusCode,
                totalAssociatedPhysician: action.associatedPhysician.totalResults,
                associatedPhysicianStatus: false
            };

        case GET_ADMIN_ASSOCIATED_PHYSICIAN_FAILURE:
            return {
                ...state,
                associatedPhysicianStatus: false
            };

        case GET_USER_ROLE:
            return {
                ...state,
                userRole: []
            };

        case GET_USER_ROLE_SUCCESS:
            return {
                ...state,
                userRole: action.userRole.userRoles
            };

        case GET_USER_ROLE_FAILURE:
            return {
                ...state
            };

        case GET_ARDT_LIST:
            return {
                ...state
            };

        case GET_ARDT_LIST_SUCCESS:
            return {
                ...state,
                areaList: action.ardtList.AARDTList
            };
        case GET_ARDT_REGION_LIST_SUCCESS:
            return {
                ...state,
                regionList: action.ardtList.AARDTList
            };
        case GET_ARDT_DISTRICT_LIST_SUCCESS:
            return {
                ...state,
                districtList: action.ardtList.AARDTList
            };

        case GET_ARDT_SUBDISTRICT_LIST_SUCCESS:
            return {
                ...state,
                subdistrictList: action.ardtList.AARDTList
            };

        case GET_ARDT_TERRITORY_LIST_SUCCESS:
            return {
                ...state,
                territoryList: action.ardtList.AARDTList
            };
        case GET_ARDT_LEVEL4_LIST_SUCCESS:
            return {
                ...state,
                level4List: action.ardtList.AARDTList
            };

        case GET_ARDT_LIST_FAILURE:
            return {
                ...state
            };

        case GET_NEW_ASSIGNMENT:
            return {
                ...state,
                newAssignmentStatusCode: '',
                errorStatusMessage: ''
            };
        case GET_NEW_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                newAssignmentStatusCode: action.payload.statusCode,
                newAssignment: [
                    ...state.newAssignment,
                    action.payload
                ]
            };
        case GET_NEW_ASSIGNMENT_FAILURE:
            return {
                ...state,
                errorStatusCode: action.data.statusCode,
                errorStatusMessage: action.data.message
            };

        case CLEAR_NEW_ASSIGNMENT:
            return {
                ...state,
                newAssignment: [],
                newAssignmentStatusCode: ''
            };
        case SET_ADMIN_SEARCH:
            return {
                ...state,
                adminSearchOpen: action.payload
            };
        case SET_ADMIN_FILTER:
            return {
                ...state,
                adminFilterOpen: action.payload
            };
        case SET_FILTER_PAGE:
            return {
                ...state,
                filterPage: action.payload
            };
        case GET_ADMIN_DATA_FROM_SEARCH:
            return {
                ...state,
                fromAdminSearch: action.payload
            };
        case SET_SEARCH_TYPE:
            return {
                ...state,
                searachType: action.payload
            };
        case SET_ADMIN_SEARCH_PARAMS:
            return {
                ...state,
                searchParams: action.payload
            };
        case SET_USER_ROLE_CHANGE:
            {
                const userRoleBasedSelection = updateUserRole(state.userRole, action.payload);

                return {
                    ...state,
                    userRoleChange: userRoleBasedSelection
                };
            }

        case SET_LOGGED_USER_ROLE_CHANGE:
            return {
                ...state,
                userRoleChange: action.payload
            };
        case SHOW_LOCAL_EXPANDED_VIEW:
            return {
                ...state,
                showLocalExpandedView: {
                    ...action.payload
                }
            };
        case RESET_ROLES:
            return {
                ...state,
                userRole: []
            };
        case RESET_TERRITORY:
            return {
                ...state,
                territories: [],
                territoryList: [],
                territorySuccess: true
            };
        case SET_APPLIED_VIEW_ADMIN_FILTER:
            return {
                ...state,
                appliedView: action.payload,
                // appliedFilter: { ...action.payload.appliedFilter },
            };
        case SET_CLEAR_FILTER:
            return {
                ...state,
                clearFilter: action.payload
            };
        case GET_FILTER_DATA:
            return {
                ...state,
                filterDataOpen: action.payload
            };
        case SET_SELECTED_VALUE:
            return {
                ...state,
                selectedViews: action.payload
            };
        case SET_FILTER_TYPE:
            return {
                ...state,
                isFilterType: action.payload
            };

        case GET_SALES_ORG_VIEW:
            return {
                ...state,
                salesOrg: action.payload
            };
        case SET_CHECKBOX_CHECKED:
            return {
                ...state,
                checked: action.payload
            };
        case GET_DISTRICT_SUCCESS:
            return {
                ...state,
                ...action.data,
                districtSuccess: action.data.statusCode === '10001' ? true : false
            };
        case GET_DISTRICT_FAILURE:
            return {
                ...state
            };
            // case GET_DISTRICT_FAILURE:
            //     return {
            //         ...state,
            //         district: '',
            //     };
        case GET_TERRITORY_SUCCESS:
            return {
                ...state,
                ...action.data,
                territorySuccess: action.data.statusCode === '10001' ? true : false
            };
            // case GET_TERRITORY_FAILURE:
            //     return {
            //         ...state,
            //         territories: '',
            //     };
        case SET_ADMIN_FILTERS:
            return {
                ...state,
                selectedAdminFilters: action.payload
            };
        case SET_FILTER_PARAMS:
            return {
                ...state,
                filterParams: action.payload
            };
        case SET_FILTER_VIEW_ADMIN:
            return {
                ...state,
                filtervalues: action.payload
            };
        case SET_ADMIN_FILTER_PARAM_VALUES:
            return {
                ...state,
                adminFilterParamValues: action.payload
            };
        case SET_MORE_CLICK:
            return {
                ...state,
                moreClick: action.payload
            };
        case SET_POP_DONE:
            return {
                ...state,
                popDone: action.payload
            };
        case SET_SELECTED_SALESORG:
            return {
                ...state,
                selectedSalesOrgView: action.payload
            };
        case SET_SALESORGVIEW_DATA:
            return {
                ...state,
                salesOrgViewData: action.payload
            };
        case ADMINFILTERPARAMETERS[2]['districts']:
            return {
                ...state,
                districts: action.data
            };
        case ADMINFILTERPARAMETERS[2]['territory']:
            return {
                ...state,
                territories: action.data
            };
        case ADMINFILTERPARAMETERS[2]['role']:
            return {
                ...state,
                userRole: action.data
            };
        case SET_SHOW_PROXY:
            return {
                ...state,
                showProxy: action.payload
            };

        case SET_PROXYTAB_DATA:
            return {
                ...state,
                proxyTabData: action.payload
            };
        case SET_TAB_ADMIN_PROXY:
            return {
                ...state,
                accountTabActiveId: action.payload
            };
        case CLEAR_ERROR_MESSAGE:
            return {
                ...state,
                errorStatusMessage: ''
            };

        case RESET_ARDT_LIST:
            return {
                ...state,
                areaList: [],
                regionList: [],
                districtList: [],
                subdistrictList: [],
                territoryList: [],
                level4List: []
            };
        case SET_AREA:
            return {
                ...state,
                area: action.payload
            };

        default:
            {
                return {
                    ...state
                };
            }
    }
};

// export default AdminReducer;
export default persistReducer({
    key: 'adminSearchResult',
    storage: storage,
    whitelist: [
        'totalSearchRecords',
        'searchResults',
        'adminSearchOpen',
        'searchParams',
        'selectedSalesOrgView',
        'salesOrgViewData',
        'appliedView',
        'adminFilterParamValues',
        'selectedViews',
    ]
}, AdminReducer);
